import ConflictDeclarationsApi from '../../../core/api/ConflictDeclarationsApi'

export const events = {
  edit: {
    start: 'START_EDITING_CONFLICT_DECLARATIONS',
    stop: 'STOP_EDITING_CONFLICT_DECLARATIONS',
    cancel: 'CANCEL_EDITING_CONFLICT_DECLARATIONS'
  },
  fetch: {
    fetched: 'ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS'
  },
  set: {
    selectionChanged: 'ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED',
    isIndependent: 'ADVISER_CONFLICT_DECLARATIONS_SET_ISINDEPENDENT'
  }
}

const conflictDeclarationsApi = new ConflictDeclarationsApi()

const { edit, set, fetch } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  fetch: {
    conflictDeclarations: () => {
      const request = conflictDeclarationsApi.fetchingConflictDeclarations()

      return (dispatch) => {
        request.then(function (response) {
          dispatch(conflictDeclarationsApi.handleResponse(fetch.fetched, response))
        })
      }
    }
  },
  set: {
    selectionChanged: (conflictDeclaration) => ({
      type: set.selectionChanged,
      conflictDeclaration
    }),
    isIndependent: () => ({
      type: set.isIndependent
    })
  }
}
